import React, { Component } from 'react';
import { Button, Table, Segment, Header, Form, List, Dimmer, Loader }
	from 'semantic-ui-react'
import {observer} from 'mobx-react';
import { BrowserRouter as Router, Route, Link } from "react-router-dom";


class Reports extends Component {

  constructor(props) {
  	super(props);
  	this.state = {
		  		    visible: false,
		         }
  }

  componentDidMount() {
  	//rvwstore.loadRvwDocs();
  }



  render() {
        return(
	            <div className="user-actions">

	                <div className= "title">
	                   <h4 align="left">Reports </h4>
	                </div>

	                <div className="buyer-actions">
						<div className="flex">
						    <Button inverted primary className="mr-5" ><Link to="/rvwpenrep">1. Review Pending Report</Link></Button>
						    <Button inverted primary className="mr-5"><Link to="/rvwdrep">2. Reviewed Document Report</Link></Button>
						    <Button inverted primary className="mr-5"><Link to="/apppenrep">3. Approval Pending Report</Link></Button>
						    <Button inverted primary className="mr-5"><Link to="/appdrep">4. Approved Document Report</Link></Button>
						    <Button inverted primary className="mr-5"><Link to="/docgrprep">5. Document Groups Report</Link></Button>
						</div>

    				</div>


	            </div>
              )
  }
}

export default observer(Reports);



// WEBPACK FOOTER //
// ./src/containers/Reports.js